import { memo } from 'react';
import { useSelector } from 'react-redux';

import { MessageSquareIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

import { AssetModalPanel, useAssetModalPanelContext } from '~/providers/AssetModalPanelContextProvider';
import { centralizedClipOpenDiscussionCountSelector } from '~/store/centralizedClip/selectors';

export const MobileCommentsTab = memo(() => {
  const openDiscussionCount = useSelector(centralizedClipOpenDiscussionCountSelector);
  const { showPanel } = useAssetModalPanelContext();

  return (
    <div className="relative">
      <IconButton
        adsIcon
        data-testid="COMMENTS_PANEL"
        appearance="ghost"
        color="gray"
        icon={MessageSquareIcon}
        // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
        onClick={() => showPanel(AssetModalPanel.COMMENTS)}
        size="large"
        label="Comments panel"
      />
      {!!openDiscussionCount && openDiscussionCount > 0 && (
        <div className="absolute top-[7px] right-[7px] size-2.5 rounded-full ads:bg-error bg-red-9" />
      )}
    </div>
  );
});

MobileCommentsTab.displayName = 'PrivateMobileCommentsTab';
